import { render } from "./Morning.vue?vue&type=template&id=5438295f&scoped=true"
import script from "./Morning.vue?vue&type=script&lang=js"
export * from "./Morning.vue?vue&type=script&lang=js"

import "./Morning.vue?vue&type=style&index=0&id=5438295f&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5438295f"]])

export default __exports__